const LOG_LEVEL = process.env.NODE_ENV === 'development' ? 'debug' : 'info';

const levels = {
  error: 0,
  warn: 1,
  info: 2,
  debug: 3,
};

const canLog = (level) => levels[level] <= levels[LOG_LEVEL];

export const logger = {
  error: (...args) => {
    if (canLog('error')) {
      console.error('[ERROR]', ...args);
    }
  },
  warn: (...args) => {
    if (canLog('warn')) {
      console.warn('[WARN]', ...args);
    }
  },
  info: (...args) => {
    if (canLog('info')) {
      console.info('[INFO]', ...args);
    }
  },
  debug: (...args) => {
    if (canLog('debug')) {
      console.debug('[DEBUG]', ...args);
    }
  },
};

// If you prefer a default export:
// export default logger;